import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

@createModule('ICalDownload')
/**
 * iCal-download module implementation.
 */
export class ICalDownload extends TerrificSpec {

	start(resolve: Function) {
		const $ctx = $(this._ctx);
        $(".js-button").on('click', () => this.downLoadCalendar($ctx));
		resolve();
	}

	
	stop() { }

	downLoadCalendar($container :JQuery<HTMLElement>){
		var calendarString=$container.attr("data-CalendarResult");
		window.open( "data:text/calendar;charset=utf8," +calendarString);
	}
}
